module.exports = __webpack_public_path__ + "img/sintesis.b2290c65.svg";